import React from 'react'
import UsersTable from '@components/Users/UsersTable'
import { useUser } from '@state/uses/users'
import { MainPageWrapper } from '@appearance/styled'

export default ({}) => {
    const user = useUser()

    if (!user || !user.is_admin) {
        return null
    }

    return (
        <MainPageWrapper>
            <UsersTable />
        </MainPageWrapper>
    )
}
